import { Component, h, Prop, Element } from '@stencil/core';
/**
 * COMPNAME is for creating a table for event items.
 *
 * <em>For More Information:</em>
 * AEM Component- ui.apps/src/main/content/jcr_root/apps/brand/aafp/components/content/aafp-event-table
 * Sling Model- core/src/main/java/org/aafp/aem/core/models/AafpEventTableModel.java
 */
@Component({
  tag: 'aafp-event-table',
  shadow: false,
})
export class AafpEventTable {
  /**
   * For creating the title of the event table
   */
  @Prop() eventTableTitle: string;

  @Element() element: HTMLElement;

  render() {
    return (
      <div class="adl-event-table">
        <div class="adl-event-table__title adl-h3 adl-background-color--lightest">{this.eventTableTitle}</div>
        <div class="adl-event-table__items">
          <slot name="event-table-items" />
        </div>
      </div>
    );
  }
}
